<template>
  <CContainer fluid>
    <h3>Contratos de Arrendamiento</h3>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  @click="() => {
                    searchWord = '';
                    getData(1);
                }">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" 
                  @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol>
            <CButton
              color="success"
              class="mt-4"
              :to="endpointAddRentContract">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable
          hover
          class="table-hover-icons"
          responsive
          :items="rentContracts"
          :fields="fields"
          :items-per-page="itemsPerPage"
          @row-clicked="(item, index, _columnName, e) => {
            goToRentContract(item.id_ContratoArrendamiento)
          }">
          <template #documento="{item}">
            <td>
              <div>
                <h4>{{ item.numero }}</h4>
              </div>
              <div>
                <span>{{ item.prefijo }}</span>
              </div>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <CIcon name="cil-building" class="mr-1" />
                <span>{{ item.directorio }}</span>
              </div>
              <div>
                <i class="bi bi-postcard mr-1"></i>
                <span>{{ item.identificacion }}</span>
              </div>
              <div>
                <i class="bi bi-person-workspace mr-1"></i>
                <span>{{ item.personal }}</span>
              </div>
            </td>
          </template>                    
          <template #estado="{item}">
            <td>
              <div>
                <CIcon name="cil-calendar" class="text-info mr-1" />
                <span>{{ item.fecha_Emision }}</span>
              </div>
              <div v-if="item.fecha_Vencimiento">
                <CIcon name="cil-calendar" class="text-s3orange mr-1" />
                <span>{{ item.fecha_Vencimiento }}</span>
              </div>
              <div v-if="item.estado == 'A'">
                <i class="bi bi-emoji-smile text-success h5 mr-1"></i>
                <span>Activo</span>
              </div>
              <div v-if="item.estado == 'I'">
                <i class="bi bi-emoji-frown text-danger h5 mr-1"></i>
                <span>Inactivo</span>
              </div>
              <div v-if="item.tipo_Contrato == 'A'">
                <i class="bi bi-unlock mr-1"></i>
                <span>Abierto</span>
              </div>
              <div v-if="item.tipo_Contrato == 'C'">
                <i class="bi bi-lock mr-1"></i>
                <span>Cerrado</span>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td class="d-flex justify-content-end">
              <div class="hover-actions">
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Borrar contrato'" 
                  @click="tryDelete($event, item.id_ContratoArrendamiento)">
                  <i class="bi bi-trash text-danger h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Agregar productos'"
                  @click="goToRentedProducts(item.id_ContratoArrendamiento)">
                  <i class="bi bi-folder-plus text-s3yellow h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Descargar Inventario'" 
                  @click="e => processRentedProducts(e, item.id_ContratoArrendamiento)">
                  <i class="bi bi-boxes text-s3brown h4 hover-icon"></i>
                </a>
              </div>

                <!-- <a href="#" 
                  class="text-dark" 
                  @click="toggleDocument($event, item)">
                  <CIcon :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" class="text-dark" />
                </a> -->
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="mb-1" :show="item._toggled">
              <CRow>
                <CCol col="sm-12" class="d-flex justify-content-end">
                  <a href="#" 
                    class="mr-3"
                    v-c-tooltip="'Borrar contrato'" 
                    @click="tryDelete($event, item.id_ContratoArrendamiento)">
                    <i class="bi bi-trash text-danger h4"></i>
                  </a>
                  <a href="#" 
                    class="mr-3"
                    v-c-tooltip="'Agregar productos'"
                    @click="goToRentedProducts(item.id_ContratoArrendamiento)">
                    <i class="bi bi-folder-plus h4"></i>
                  </a>
                </CCol>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>  
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>
  </CContainer>
</template>

<script>
  import { ref } from "vue";
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  
  import CONSTANTS from "@/constants";
  import { 
    dataGridContratosArrendamientos,
    crudContratoArrendamiento
  } from "@/apis/rents";

  const fields = [
    { 
      key: "documento", 
      label: "Número",
      _style:"text-align:center;"
    },
    { 
      key: "empresa", 
      label: "Empresa",
      _style:"text-align:center;"
    },
    { 
      key: "estado", 
      label: "Estados",
      _style:"text-align:center;"
    },
    { 
      key: "acciones",
      label: "",
      _style:"text-align:center;"
    }
  ]

  export default {
    name: "RentContracts",
    data() {
      return {
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        fields,
        rentContracts: [],
        idSelectedRentContract: ""
      }
    },
    components: {
      LoadingCover
    },
    methods: {
      async getData(page, search) {
        this.loading = true

        try {
          this.searchWord = search
          const  { count, results } = await dataGridContratosArrendamientos(this, page, search)

          this.rentContracts = results;
          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      goToRentContract(idRentContract) {
        idRentContract = idRentContract.replaceAll("-", "")

        this.$router.push({path: `${this.rootPath}/editar/${idRentContract}`})
      },
      goToRentedProducts(idRentContract) {
        idRentContract = idRentContract.replaceAll("-", "")

        this.$router.push({path: `${this.rootPath}/${idRentContract}/productosarrendamiento`});
      },
      tryDelete(e, idRentContract){
        e.preventDefault();
        e.stopPropagation();

        this.idSelectedRentContract = idRentContract

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRentContract();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        });
      },
      async deleteRentContract() {
        try {
          this.loading = true

          await crudContratoArrendamiento(this, "delete", this.idSelectedRentContract);

          this.getData();

          this.$store.commit("setAlert", {
            color: "success",
            message: "Acción exitosa",
            show: 5
          })
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      processRentedProducts(e, rentContractId) {
        rentContractId

        e.preventDefault();
        e.stopPropagation();
        
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Confirmar"
        // CONSTANTS.configSimpleConfirm.confirmButtonColor = "s3yellow"

        this.$confirm("¿Confirma que desea realizar un documento de salida de inventario de los productos del contrato de arrendamiento?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRentContract();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        });
      },
      toggleDocument(e, item) {
        e.preventDefault();
        e.stopPropagation();

        this.$set(item, "_toggled", !item._toggled)
        // this.$nextTick(() => {})
      }
    },
    setup() {
      const rootPath = ref("");
      const endpointAddRentContract = ref("");

      return {
        rootPath,
        endpointAddRentContract
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.endpointAddRentContract = `${this.rootPath}/agregar`;

      console.log(this.rootPath);
      

      this.getData()
    } 
  }
</script>
